import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import BootstrapVue from "bootstrap-vue";

export const Bootstrap = {
	install(vue:any, options:any){
		vue.use(BootstrapVue);
	}
};